import {
  VersicherungsangabenConfig,
  VersicherungsangabenSectionConfig,
} from '@/features/Versicherungsangaben/types';
import { SECTION } from '@/components/layout/types';
import { PropertyContractLayoutSlots } from '@/views/Layouts/Contract/types';

const inputConfig: VersicherungsangabenSectionConfig = {
  [SECTION.INPUT_VN]: {
    label: 'Angaben zum Versicherungsnehmer',
    component: () =>
      import(
        '@/features/Sparten/woh/sections/input/InputVersicherungsnehmer.vue'
      ),
  },
  [SECTION.PROPERTY_INPUT_RISIKOORT]: {
    label: 'Angaben zum Risikoort',
    component: () =>
      import('@/features/Sparten/woh/sections/input/InputRisikoort.vue'),
  },
  [SECTION.INPUT_ABSICHERUNG]: {
    label: 'Gewünschte Absicherung',
    component: () =>
      import('@/features/Sparten/woh/sections/input/InputAbsicherung.vue'),
  },
  [SECTION.INPUT_BEITRAGSREDUZIERUNG]: {
    label: 'Mögliche Beitragsreduzierung',
    disabledPaths: ['demvRabattiert'],
    component: () =>
      import(
        '@/features/Sparten/woh/sections/input/InputBeitragsreduzierung.vue'
      ),
  },
};

const contractConfig: VersicherungsangabenSectionConfig<PropertyContractLayoutSlots> =
  {
    [SECTION.CONTRACT_CLIENT]: {
      label: 'Persönliche Angaben',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractClient.vue'
        ),
    },
    // [SECTION.CONTRACT_COMPANY_QUESTION]: {
    //   label: 'Gesellschaftsfragen',
    //   requiresContractTariff: true,
    //   component: () =>
    //     import(
    //       '@/features/Sparten/shared/sections/property/contract/ContractCompanyQuestions.vue'
    //     ),
    // },
    [SECTION.PROPERTY_CONTRACT_ELEMENTARVERSICHERUNG]: {
      label: 'Angaben zur Elementarversicherung',
      component: () =>
        import(
          '@/features/Sparten/woh/sections/contract/ContractElementar.vue'
        ),
    },
    [SECTION.PROPERTY_INSURED_OBJECT]: {
      label: 'Angaben zum versicherten Objekt',
      component: () =>
        import(
          '@/features/Sparten/woh/sections/contract/ContractInsuredObject.vue'
        ),
    },
    [SECTION.WOH_ADDITIONAL_INFORMATION_INSURED_OBJECT]: {
      label: 'Weitere Angaben zum versicherten Objekt',
      component: () =>
        import(
          '@/features/Sparten/woh/sections/contract/ContractAdditionalInsuredObject.vue'
        ),
    },
    [SECTION.PROPERTY_CONTRACT_PREVIOUS_INSURANCE]: {
      label: 'Vorversicherung',
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractPreviousInsuranceAndDamage.vue'
        ),
      slots: {
        previousDamageTop: () =>
          import(
            '@/features/Sparten/woh/sections/contract/ContractPreviousDamage.vue'
          ),
      },
    },
    [SECTION.CONTRACT_BANK_TRANSFER_INFORMATION]: {
      label: 'Zahlungsinformation',
      requiresContractTariff: true,
      component: () =>
        import(
          '@/features/Sparten/shared/sections/property/contract/ContractBankTransferInformation.vue'
        ),
    },
  };

export const wohVersicherungsangabenConfig: VersicherungsangabenConfig = {
  inputConfig,
  contractConfig,
};
